module.exports = __webpack_public_path__ + "img/eco-cabins.0b83148d.jpg";